import { useEffect, useState } from "react";
import AxiosInstance from "../Axios";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";


const urlApi = '/languages';

const LangugesPanel = ({data, setData}) => {
    const navigate = useNavigate();

    const [languagesList, setLaguagesList] = useState([]);
    const [language, setLaguage] = useState((data != undefined &&  data.language != undefined)? data.language.name: 'en');
    const [translations, setTranslations] = useState((data != undefined && data.translations != undefined)? data.translations: false);

    const getLangs  = () =>{
        AxiosInstance.get(`${urlApi}?page=1`).then((response) => {
            setLaguagesList(response.data['hydra:member'])
        })
    }

    useEffect(() =>  {
        setLaguage((data != undefined &&  data.language != undefined)? data.language.name: 'en');
        setTranslations((data != undefined && data.translations != undefined)? data.translations: false);
        getLangs();
    }, [data]);


    const CreateTranslate  = (e, l) => {
        
        const data_response = {
            name: "",
            shortName: "",
            description: "",
            type: data.type,
            edrpou: data.edrpou
          };
        data_response['language'] = `/api/languages/${l.id}`;
        data_response['translation'] = `/api/accounts/${data.id}`;
        AxiosInstance.post(`/accounts`, data_response).then((response) => {
            if (response.status === 201) {
              setData(response.data);
              return navigate(`/accounts/update/${response.data.id}`);
            }
          });
    }


    return (
        <div>
            {/* <div>: </div> */}
            <div>
                <ul>
                    {
                        (data != "" && data.translation != undefined && data.translation.id !=  undefined) ?
                            <>
                                <h4>Переклад: {language}</h4>
                                <Link to={`/accounts/update/${data.translation.id}`}>Повернутися до EN</Link>
                            </>
                        :
                            <>
                                <h4>Переклад: {language}</h4>
                                {/* <li className='btn btn-secondary text-white'>{language}</li> */}
                                {data != "" && languagesList.map((l) =>{
                                    let search = true;
                                    // console.log('translations', translations);
                                    if(l.name != language){
                                        if(translations != false){
                                            let t = translations.filter(t => t.language.key === l.key)
                                            if(t.length > 0)
                                                return (<Button variant="outline-secondary ml-5" ><Link to={`/accounts/update/${t[0].id}`} >{l.key}</Link></Button>);
                                            else
                                                search = false;
                                        }else{
                                            search = false;
                                        }
                                    }
                                    if(!search)
                                        return (<Button 
                                            variant="outline-secondary mr-5"
                                            onClick={(e) => {CreateTranslate(e, l)}}
                                        >
                                            додати  <b>{l.key}</b>
                                        </Button>);
                                })}
                            </>
                    }
                </ul>
            </div>
        
        </div>
    )
}

export default LangugesPanel;